<template>
  <div class="h-100 d-flex flex-column">
    <div id="leafMap" class="flex-grow-1"></div>
    <div class="d-flex justify-content-end align-items-baseline border-bottom p-2 fs-6 text-secondary">
      <span class="me-3 d-inline-flex align-items-center">
        <a role="button" class="badge bg-light border border-secondary text-secondary text-decoration-none fw-normal me-1" @click="fitBoundsToMarkers(false)">コース全体表示</a>
        <label class="xsmall d-inline-flex align-items-center"><input type="checkbox" v-model="wholeCourseContainsCurrentLocation" class="me-1">現在位置を含む</label>
      </span>
      <a role="button" class="badge bg-light border border-secondary text-secondary text-decoration-none fw-normal" @click="reloadCurrentLocation"><i class="fas fa-redo me-1"></i> 現在位置</a>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import  'leaflet/dist/leaflet.css'
import  L from 'leaflet'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import 'leaflet-arrowheads'
import IznvSound from 'packs/plugins/iznv-sound'

export default {
  data: function () {
    return {
      audioContext: new AudioContext(),
      lMap: null,
      aaa: 'bbb',
      mapLayerUrl: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',//OpenStreetMap
      // mapLayerUrl: 'https://cyberjapandata.gsi.go.jp/xyz/pale/{z}/{x}/{y}.png',//国土地理院淡色地図
      // mapLayerUrl: 'https://a.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
       
      lMapAttribution: '&copy; <a href="https://osm.org/copyright">OpenStreetMap contributors</a>',
      mapZoom: 12,
      mapCenter: {
        lat: 34.81455563153658,
        lng: 138.94715756783768,
        // lat: 35,
        // lng: 135,
      },
      mapStateToLoad: null,
      currentLocation: {
        lat: 0,
        lng: 0,
      },
      lCurrentLocationMarker: null,
      lCurrentLocationMarkerZindexOffset: 2000,
      lCurrentLocationMarkerSize: [7, 7],
      lCurrentLocationMarkerStrokeColor: 'rgba(56, 134, 189, .8)',
      lCurrentLocationMarkerFillColor: 'rgb(56, 134, 189)',
      getCurrentLocationBusy: false,
      wholeCourseContainsCurrentLocation: false,
      markerSize: { width: 30, height: 30 },
      markerSizeAlt: { width: 50, height: 50 },
      markerZIndexOffset: -1000,
      accommodationMarkerSize: { width: 30, height: 30 },
      accommodationMarkerZIndexOffset: -5000,
      selectedMarkerZIndexOffset: 1000,
      distanceRangeOverlayMarkerZIndexOffset: -6000,
      lSelectedOverlayMarker: null,
      // lSelectedOverlayMarkerStrokeColor: '#7f7fff',
      lSelectedOverlayMarkerStrokeColor: '#66f',
      lSelectedMarker: null,
      // lVisitedOverlayMarkerStrokeColor: 'rgba(127, 127, 255, .5)',
      lVisitedOverlayMarkerStrokeColor: 'rgba(255, 0, 0, .8)',
      lVisitedMarker: null,
      lDistanceRangeOverlayMarker: null,
      // lDistanceRangeOverlayMarkerStrokeColor: '#66f',
      // lDistanceRangeOverlayMarkerFillColor: 'rgba(127, 127, 255, .5)',
      lDistanceRangeOverlayMarkerStrokeColor: 'rgba(127, 127, 255, .2)',
      lDistanceRangeOverlayMarkerFillColor: 'rgba(127, 127, 255, .2)',
      distanceRangePixelChanged: false,
      markerSettingup: false,
      lMarkers: [],
      lAccommodationMarkers: [],
      lLines: [],
      lLineArrowheadOption: {
        size: '12px',
        frequency: '80px',
      },
    }
  },
  props: {
    destinationDistanceThreshold: 0,
    enableSound: false,
  },
  computed: {
    lMarkerIconOption: function() {
      return {
        iconSize: {
          x: this.markerSize.width,
          y: this.markerSize.height,
        },
        iconAnchor: {
          x: this.markerSize.width / 2,
          y: this.markerSize.height / 2,
        },
      };
    },
    lAccommodationIconOption: function() {
      return {
        iconSize: {
          x: this.accommodationMarkerSize.width,
          y: this.accommodationMarkerSize.height,
        },
        iconAnchor: {
          x: this.accommodationMarkerSize.width / 2,
          y: this.accommodationMarkerSize.height / 2,
        },
      };
    },
    lSelectedOverlyMarkerIconOption: function() {
      return {
        iconSize: {
          x: this.markerSize.width + 4,
          y: this.markerSize.height + 4,
        },
        iconAnchor: {
          x: (this.markerSize.width + 4) / 2,
          y: (this.markerSize.height + 4) / 2,
        },
        className: 'selectedOverlayMarker',
        html: '<div style="width:100%;height:100%;border:2px solid ' + this.lSelectedOverlayMarkerStrokeColor + ';border-radius:50%;"></div>'
      };
    },
    lVisitedOverlyMarkerIconOption: function() {
      return {
        iconSize: {
          x: this.markerSize.width + 4,
          y: this.markerSize.height + 4,
        },
        iconAnchor: {
          x: (this.markerSize.width + 4) / 2,
          y: (this.markerSize.height + 4) / 2,
        },
        className: 'visitedOverlayMarker',
        html: '<div style="width:100%;height:100%;border:2px solid ' + this.lVisitedOverlayMarkerStrokeColor + ';border-radius:50%;"></div>'
      };
    },
    lDistanceRangeOverlyMarkerIconOption: function() {
      console.log('lDistanceRangeOverlyMarkerIconOption distanceRangePixel: ', this.distanceRangePixel);
      this.distanceRangePixelChanged;
      this.distanceRangePixelChanged = false;
      return {
        iconSize: {
          x: this.distanceRangePixel * 2,
          y: this.distanceRangePixel * 2,
        },
        iconAnchor: {
          x: this.distanceRangePixel,
          y: this.distanceRangePixel,
        },
        className: 'distanceRangeOverlayMarker',
        html: '<div style="width:100%;height:100%;border:2px solid ' + this.lDistanceRangeOverlayMarkerStrokeColor + ';border-radius:50%;background-color:' + this.lDistanceRangeOverlayMarkerFillColor + '"></div>'
      };
    },
    lCurrentLocationMarkerIconOption: function() {
      return {
        iconSize: this.lCurrentLocationMarkerSize,
        iconAnchor: {
          x: (this.lCurrentLocationMarkerSize.x) / 2,
          y: (this.lCurrentLocationMarkerSize.y) / 2,
        },
        className: 'currentLocationMarker',
        html: '<div style="width:100%;height:100%;border:1px solid ' + this.lCurrentLocationMarkerStrokeColor + ';border-radius:50%;background:' + this.lCurrentLocationMarkerFillColor + ';"></div>'
      };
    },
    distanceRangePixel: function() {
      if(!this.lMap) return 0;
      const bounds = this.lMap.getBounds();
      const distance = this.lMap.distance(bounds.getNorthEast(), bounds.getNorthWest());
      console.log('distanceRangePixel distance: ', distance);
      const size = this.lMap.getSize();
      console.log('distanceRangePixel size.x: ', size.x);
      const rangePixel = Math.round(size.x * this.destinationDistanceThreshold / distance);
      console.log('distanceRangePixel rangePixel: ', rangePixel);
      // this.refreshDistanceRangeOverlayMarker();
      return rangePixel;
    },
  },
  methods: {
    storeMapState: function() {
      console.log('storeMapState called.', this.lMap.getCenter(), this.lMap.getZoom());
      this.refreshDistanceRangeOverlayMarker();
      this.$emit('map-state-changed', {
        center: {
          lat: this.lMap.getCenter().lat,
          lng: this.lMap.getCenter().lng,
        },
        zoom: this.lMap.getZoom(),
      });
    },
    loadMapState: function(mapState) {
      this.mapZoom = mapState.zoom;
      this.mapCenter = mapState.center;
    },
    loadMap: function(force = false) {
      this.lMap = L.map('leafMap').setView(this.mapCenter, this.mapZoom);
      this.lMap.zoomControl.setPosition('bottomright');
      L.tileLayer(this.mapLayerUrl, {
        attribution: this.lMapAttribution,
      }).addTo(this.lMap);
      this.storeMapState();
      // this.lMap.on('load', this.storeMapState);
      this.lMap.on('zoomend', this.storeMapState);
      this.lMap.on('moveend', this.storeMapState);
      // this.lMap.on('resize', e => console.log('lMap resized oldSize, newSize: ', e.oldSize, e.newSize));
      if(!force) this.$store.commit("setMapLoaded");
      this.setupMarkers(force);
    },
    setCenter: function(geometry) {
      if(this.lMap) this.lMap.panTo(geometry);
      this.storeMapState();
    },
    fitBoundsToMarkers: async function(ignoreCurrentLocation = true, ...options) {
      console.log('fitBoundsToMarkers options: ', options);
      if(!options.length) options = ["checkPoint", "line", "accommodation"];
      const lats = [];
      const lngs = [];
      if(options.indexOf("checkPoint") >= 0) {
        lats.splice(-1, 0, ...(this.lMarkers.map(marker => marker.location.geometry.lat)));
        lngs.splice(-1, 0, ...(this.lMarkers.map(marker => marker.location.geometry.lng)));
      }
      if(options.indexOf("accommodation") >= 0) {
        lats.splice(-1, 0, ...(this.lAccommodationMarkers.map(marker => marker.location.geometry.lat)));
        lngs.splice(-1, 0, ...(this.lAccommodationMarkers.map(marker => marker.location.geometry.lng)));
      }
      if(options.indexOf("line") >= 0) {
        lats.splice(-1, 0, ...this.lLines.map(line => line.getLatLngs().map(p => p.lat)).flat());
        lngs.splice(-1, 0, ...this.lLines.map(line => line.getLatLngs().map(p => p.lng)).flat());
      }
      if(!lats.length) return;
      if(!ignoreCurrentLocation && this.wholeCourseContainsCurrentLocation) {
        try {
          const result = await this.reloadCurrentLocation(false);
          if(!result) throw new Error('failed to get current location..');
          lats.push(this.currentLocation.lat);
          lngs.push(this.currentLocation.lng);
        } catch(e) {
          console.error(e);
        }
      }
      console.log('fitBoundsToMarkers called. options, markers, lines: ', options, this.markers, this.lines);
      // const lats = this.markers.map(marker => marker.location.geometry.lat).concat(this.lines.map(line => line.getPath().getArray().map(p => p.lat())).flat());
      // const lngs = this.markers.map(marker => marker.location.geometry.lng).concat(this.lines.map(line => line.getPath().getArray().map(p => p.lng())).flat());
      const bounds = {
        north: lats.reduce((a, b) => Math.max(a, b)),
        east: lngs.reduce((a, b) => Math.max(a, b)),
        south: lats.reduce((a, b) => Math.min(a, b)),
        west: lngs.reduce((a, b) => Math.min(a, b)),
      };
      const latLngBounds = [
        [bounds.north, bounds.east],
        [bounds.south, bounds.west],
      ];
      this.lMap.fitBounds(latLngBounds, {
        padding: [40, 40],
      });
      // L.rectangle(latLngBounds, {
      //   color: 'lightsalmon',
      //   weight: 2,
      // }).addTo(this.lMap);
      // console.log('fitBOundsToMarkers map size, origin pixelBounds: ', this.lMap.getSize(), this.lMap.getPixelOrigin(), this.lMap.getPixelBounds());
    },
    loadCourse: function(mapState) {
      this.mapStateToLoad = mapState;
      this.setupMarkers();
    },
    loadLines: function() {
      const linesData = this.$store.state.selectedCourse.lines;
      console.log('loadLines linesData: ', linesData);
      if(!linesData || !linesData.length) return;
      linesData.forEach(data => {
        this.newLine(data.color, data.path);
      });
    },
    setupMarkers: function(force = false) {
      if(
        (
          !this.$store.state.mapLoaded || 
          !this.$store.state.dataReady ||
          this.markerSettingup
        ) && !force
      ) return;
      console.log("setupMarkers started.");
      this.markerSettingup = true;
      const checkPoints = this.$store.getters.checkPoints;
      const accommodations = this.$store.getters.accommodations;
      console.log('setupMarkers checkPoints, accommodations: ', checkPoints, accommodations);
      this.clearMarkersAndLines();
      checkPoints.forEach(checkPoint => {
        this.addMarker(checkPoint);
      });
      if(!force) this.checkPointSelected(false);
      accommodations.forEach(accommodation => {
        this.addAccommodationMarker(accommodation);
      });
      this.loadLines();
      if(this.mapStateToLoad) {
        console.log('setupMarkers mapStateToLoad.center: ', this.mapStateToLoad.center);
        this.lMap.stop().flyTo([this.mapStateToLoad.center.lat, this.mapStateToLoad.center.lng], this.mapStateToLoad.zoom, {duration: 0.25});
        // this.lMap.panTo([this.mapStateToLoad.center.lat, this.mapStateToLoad.center.lng]);
        // this.lMap.setZoom(this.mapStateToLoad.zoom);
        // this.storeMapState();
        this.mapState = null;
      } else this.fitBoundsToMarkers();
      this.markerSettingup = false;
      this.$emit("map-got-ready");
    },
    lMarkIcon: function(mark) {
      const iconUrl = mark.isClosed ? mark.category.icons.icon_alt.url : mark.category.icons.icon.url;
      return L.icon(Object.assign({}, this.lMarkerIconOption, {iconUrl: iconUrl}));
    },
    addMarker: function(checkPoint) {
      const mark = checkPoint.mark_data;
      const location = mark.location;
      const lMarkerOption = {
        icon: this.lMarkIcon(mark),
        zIndexOffset: this.markerZIndexOffset,
      }
      const lMarker = L.marker(location.geometry, lMarkerOption).addTo(this.lMap);
      let lVisitedOverlayMarker = null;
      console.log('addMarker checkPoint.visited: ', checkPoint.visits);
      if(checkPoint.visits.length) {
        const lVisitedOverlayMarkerIcon = L.divIcon(this.lVisitedOverlyMarkerIconOption);
        lVisitedOverlayMarker = L.marker(location.geometry, {
          icon: lVisitedOverlayMarkerIcon,
          zIndexOffset: this.markerZIndexOffset + 10,
          interactive: false,
        }).addTo(this.lMap);
      }
      console.log('addMarker lMarkerOption: ', lMarkerOption);
      lMarker.checkPoint = checkPoint;
      lMarker.location = location;
      lMarker.mark = mark;
      lMarker.order = checkPoint.order;
      lMarker.checkPointType = checkPoint.check_point_type;
      lMarker.visitedOverlayMarker = lVisitedOverlayMarker;
      lMarker.on('click', (e) => {
        this.markerClicked(lMarker);
      });
      this.lMarkers.push(lMarker);
    },
    updateMarkerState: function() {
      this.lMarkers.forEach(marker => marker.setIcon(this.lMarkIcon(marker.mark)));
    },
    addAccommodationMarker: function(accommodation) {
      const mark = accommodation;
      const location = mark.location;
      const lMarker = L.marker(accommodation.location.geometry, {
        icon: L.icon(Object.assign({}, this.lAccommodationIconOption, {
          iconUrl: accommodation.category.icons.icon.url,
        })),
        zIndexOffset: this.accommodationMarkerZIndexOffset,
      }).addTo(this.lMap);
      lMarker.accommodation = accommodation;
      lMarker.location = accommodation.location;
      // let popupContent = '<div id="accommodationPopup"><h1 class="fw-normal" style="font-size:.9em;">おすすめ宿泊施設</h1>';
      // popupContent += '<h2 class="fs-6"><a href="' + accommodation.reservation_url + '">' + accommodation.name + '<br><small>→プランを見る</small></a></h2>';
      // popupContent += '</div>';
      // const accommodationPopup = L.popup({
      //   // autoClose: false,
      //   // closeOnClick: false,
      // }).setContent(popupContent);
      // lMarker.unbindPopup().bindPopup(accommodationPopup);
      // lMarker.on('popupopen', (e) => this.resetAccommodationPopupLinkMethod());
      lMarker.on('click', (e) => this.accommodationMarkerClicked(lMarker));
      this.lAccommodationMarkers.push(lMarker);
    },
    clearMarkersAndLines: function() {
      this.clearMarkers();
      this.clearLines();
    },
    clearMarkers: function() {
      if(this.lSelectedOverlayMarker) {
        this.lSelectedOverlayMarker.remove();
        this.lSelectedOverlayMarker = null;
      }
      this.lMarkers.forEach(marker => {
        if(marker.visitedOverlayMarker) marker.visitedOverlayMarker.remove();
        marker.remove()
      });
      this.lMarkers.splice(0);
      this.lAccommodationMarkers.forEach(marker => marker.remove());
      this.lAccommodationMarkers.splice(0);
    },
    clearLines: function() {
      this.lLines.forEach(line => line.remove());
      this.lLines.splice(0);
    },
    markerClicked: function(marker) {
      console.log('markerClicked. marker.mark.name: ', marker.mark.name, marker);
      if(typeof marker.isPopupOpen !== 'undefined' && marker.isPopupOpen()) {
        console.log('popup is open!');
        return;
      }
      const lMarkers = this.lMarkers.filter(m => m.mark.id === marker.mark.id);
      if(lMarkers.length > 1) this.showCheckPointPopup(lMarkers);//複数チェックポイントが同じ場所にある場合
      else this.checkPointClicked(marker);
    },
    checkPointClicked: function(marker) {
      this.$emit("check-point-clicked", marker.checkPoint);
    },
    accommodationMarkerClicked: function(marker) {
      console.log('accommodatonMarkerClicked. marker: ', marker);
      if(typeof marker.isPopupOpen !== 'undefined' && marker.isPopupOpen()) {
        console.log('popup is open!');
        return;
      }
      this.showAccommodationPopup(marker);//宿泊施設は1マーカーに1つ
    },
    showCheckPointPopup: function(markers) {
      console.log('showCheckPointPopup called. popup: ', markers[0].getPopup());
      if(!markers[0].getPopup()) {
        console.log('will set popupContent.');
        let popupContent = '<div id="checkPointPopup"><h1 class="fs-6">' + markers[0].mark.name + '</h1>';
        markers.forEach((marker, index) => {
          popupContent += '<span class="badge bg-secondary rounded-circle me-2" data-marker-index="' + index + '">' + marker.order + '</span>';
        });
        popupContent += '</div>';
        const checkPointPopup = L.popup({
          // autoClose: false,
          // closeOnClick: false,
        }).setContent(popupContent);
        markers[0].unbindPopup().bindPopup(checkPointPopup);
        markers[0].off('popupopen').on('popupopen', e => {
          $('.leaflet-container a.leaflet-popup-close-button').on('click', e => e.preventDefault());
          this.resetCheckPointPopupClickMethod(markers);
        });
        markers[0].off('popupclose').on('popupclose', e => console.log('popupclose e: ', e));
      }
      markers[0].openPopup();
    },
    resetCheckPointPopupClickMethod: function(markers) {
      $('#checkPointPopup span').off('click').on('click', e => {
        console.log('#checkPointPopup span clicked. e: ', e);
        const index = +(e.target.dataset.markerIndex);
        markers[0].closePopup();
        this.checkPointClicked(markers[index]);
      });
    },
    showAccommodationPopup: function(marker) {
      const accommodation = marker.accommodation;
      let popupContent = '<div id="accommodationPopup"><h1 class="fw-normal" style="font-size:.9em;">おすすめ宿泊施設</h1>';
      popupContent += '<h2 class="fs-6"><a href="' + accommodation.reservation_url + '">' + accommodation.name + '<br><small>→プランを見る</small></a></h2>';
      popupContent += '</div>';
      const accommodationPopup = L.popup({
        // autoClose: false,
        // closeOnClick: false,
      }).setContent(popupContent);
      marker.unbindPopup().bindPopup(accommodationPopup);
      marker.off('popupopen').on('popupopen', e => {
        $('.leaflet-container a.leaflet-popup-close-button').on('click', e => e.preventDefault());
        this.resetAccommodationPopupLinkMethod();
      });
      if(typeof marker.openPopup !== 'undefined') marker.openPopup();
    },
    resetAccommodationPopupLinkMethod: function() {
      $('#accommodationPopup a').off('click').on('click', e => {
        const url = e.target.href;
        console.log('accommodationPopup clicked. url: ', url);
        this.$emit("open-external-page", url);
        e.preventDefault();
      });
    },

    // updateMarkMarker: function(mark, deleted = false) {
    //   const index = this.markers.findIndex(m => m.mark.id === mark.id);
    //   if(index >= 0) {
    //     this.markers[index].setMap(null);
    //     this.markers.splice(index, 1);
    //   }
    //   if(!deleted) this.addMarker(mark);
    // },
    // reloadMarkMarkers: function(newMarks) {
    //   const markersToDelete = this.markers.filter(marker => !newMarks.find(newMark => newMark.id === marker.mark.id));//1marker複数checkPointにより変更必要
    //   markersToDelete.forEach(marker => this.updateMarkMarker(marker.mark, true));
    //   newMarks.forEach(newMark => this.updateMarkMarker(newMark));
    // },
    // setSelectedLocation: function(location, newLocation = false, category = null) {
    //   this.resetMarkerIcons();
    //   const marker = newLocation ? this.addMarker(location) : this.markers.find(marker => marker.location.id === location.id);
    //   console.log('setSelectedLocation after calling addMarker.. marker: ', marker);
    //   const icon = category ? category.icons.icon.url : this.selectedLocationIcon;
    //   if(marker) marker.setIcon(icon);
    //   this.setCenter(location.geometry);
    //   this.selectedLocation = location;
    //   this.closeLocationSearch();
    // },
    // setSelectedMark: function(mark, newMark = false) {
    //   const marker = this.markers.find(marker => marker.mark.id === mark.id);
    //   if(marker) marker.setIcon(Object.assign(marker.getIcon(), { scaledSize: this.selectedMarkerSize }));
    //   this.setCenter(mark.location.geometry);
    // },
    refreshDistanceRangeOverlayMarker: function() {
      if(!this.lSelectedMarker) return;
      if(this.lSelectedMarker.checkPoint.check_point_type !== 'destination') {
        if(this.lDistanceRangeOverlayMarker) this.lDistanceRangeOverlayMarker.remove();
        return;
      }
      this.distanceRangePixelChanged = true;
      console.log('refreshDistanceRangeOverlayMarker this.lDistanceRangeOverlyMarkerIconOption:', this.lDistanceRangeOverlyMarkerIconOption);
      const lDistanceRangeOverlayMarkerIcon = L.divIcon(this.lDistanceRangeOverlyMarkerIconOption);
      const center = this.lSelectedMarker ? this.lSelectedMarker.location.geometry : [0, 0];
      if(!this.lDistanceRangeOverlayMarker) {
        this.lDistanceRangeOverlayMarker = L.marker(center, {
          icon: lDistanceRangeOverlayMarkerIcon,
          zIndexOffset: this.distanceRangeOverlayMarkerZIndexOffset,
          interactive: false,
        });
      }
      this.lDistanceRangeOverlayMarker.addTo(this.lMap);
      this.lDistanceRangeOverlayMarker.setIcon(lDistanceRangeOverlayMarkerIcon);
      this.lDistanceRangeOverlayMarker.setLatLng(center);
    },
    setSelectedCheckPoint: function(setCenter = true) {
      if(this.lSelectedMarker) {
        if(!this.lSelectedOverlayMarker) {
          const lSelectedOverlayMarkerIcon = L.divIcon(this.lSelectedOverlyMarkerIconOption);
          this.lSelectedOverlayMarker = L.marker([0, 0], {
            icon: lSelectedOverlayMarkerIcon,
            zIndexOffset: this.selectedMarkerZIndexOffset + 10,
            // interactive: false,
          }).addTo(this.lMap).on('click', e => {
            if(this.lSelectedMarker) this.markerClicked(this.lSelectedMarker);
          });
        }
        this.lSelectedOverlayMarker.setLatLng(this.lSelectedMarker.location.geometry);
        this.lSelectedMarker.setZIndexOffset(this.selectedMarkerZIndexOffset);
        console.log('setSelectedCheckPoint called. lSelectedMarker, lSelectedOverlayMarker: ', this.lSelectedMarker, this.lSelectedOverlayMarker);
        this.refreshDistanceRangeOverlayMarker();
        // if(!this.lDistanceRangeOverlayMarker) {
        //   const lDistanceRangeOverlayMarkerIcon = L.divIcon(this.lDistanceRangeOverlyMarkerIconOption);
        //   this.lDistanceRangeOverlayMarker = L.marker([0, 0], {
        //     icon: lDistanceRangeOverlayMarkerIcon,
        //     zIndexOffset: this.selectedMarkerZIndexOffset + 5,
        //     // interactive: false,
        //   }).addTo(this.lMap);
        // }
        // this.lDistanceRangeOverlayMarker.setLatLng(this.lSelectedMarker.location.geometry);
        if(setCenter) this.setCenter(this.lSelectedMarker.mark.location.geometry);
      }
    },
    resetMarkerIcons: function() {
      this.lMarkers.forEach(marker => marker.setZIndexOffset(this.markerZIndexOffset));
    },
    newLine: function(color, latLngArray) {
      const lLine = L.polyline(latLngArray, {
        color: color,
      }).arrowheads(this.lLineArrowheadOption).addTo(this.lMap);
      this.lLines.push(lLine);
    },
    reloadCurrentLocation: async function(setCenter = true, emit = false, callback = null) {
      if(this.getCurrentLocationBusy) return;
      this.getCurrentLocationBusy = true;
      if(this.enableSound) {
        const source = this.audioContext.createBufferSource();
        source.connect(this.audioContext.destination);
        source.buffer = this.audioContext.createBuffer(1, 1, 22050);
        source.onended = () => source.disconnect(0);
        source.start(0);
      }
      let result = true;
      try {
        const position = await this.getCurrentLocation();
        this.currentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        if(!this.lCurrentLocationMarker) {
          this.lCurrentLocationMarker = L.marker([0, 0], {
            icon: L.divIcon(this.lCurrentLocationMarkerIconOption),
            zIndexOffset: this.lCurrentLocationMarkerZindexOffset,
          }).addTo(this.lMap);
        }
        console.log('reloadCurrentLocation lCurrentLocationMarker: ', this.lCurrentLocationMarker);
        this.lCurrentLocationMarker.setLatLng(this.currentLocation);
        if(setCenter) this.setCenter(this.currentLocation);
        if(this.enableSound && this.currentLocationIsInRange()) {
          IznvSound.beep01(this.audioContext.destination, this.audioContext.currentTime);
        }
      } catch(error) {
        result = false;
        console.error(error);
      } finally {
        this.getCurrentLocationBusy = false;
        console.log('reloadCurrentLocation result: ', result);
        // if(emit) this.$emit('current-location-checked', (result ? this.currentLocation : null), callback);
        this.$emit('current-location-checked', (result ? this.currentLocation : null), callback);
        return result;
      }
    },
    currentLocationIsInRange: function() {
      if(!this.lSelectedMarker || this.lSelectedMarker.checkPoint.check_point_type !== 'destination') return false;
      const  distance = L.latLng(this.currentLocation).distanceTo(this.lSelectedMarker.checkPoint.location.geometry);
      return distance <= this.destinationDistanceThreshold;
    },
		getCurrentLocation: async function() {
			return new Promise(async (resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          position => resolve(position),
          error => reject(error)
        );
      });
		},
    resetLMap: function() {
      if(!this.lMap) return;
      this.lMap.remove();
      if(this.lSelectedOverlayMarker) {
        this.lSelectedOverlayMarker.remove();
        this.lSelectedOverlayMarker = null;
      }
      this.loadMap(true);
    },
    checkPointSelected: function(setCenter = true) {
      const selectedCheckPoint = this.$store.state.selectedCheckPoint;
      if(!selectedCheckPoint) return;
      // this.resetLMap();
      // if(this.lMap) this.lMap.invalidateSize();
      this.resetMapSize();
      this.resetMarkerIcons();
      const lSelectedMarker = this.lMarkers.find(marker => marker.mark.id === selectedCheckPoint.mark.id);
      if(lSelectedMarker) this.lSelectedMarker = lSelectedMarker;
      this.setSelectedCheckPoint(setCenter);
    },
    resetMapSize: function() {
      if(this.lMap) this.lMap.invalidateSize({
        animate: true,
      });
    },
  },
  mounted: function() {
    $('#app').on('appStateLoaded', () => {
      console.log("mapComponent appStateLoaded event received!");
      this.loadMap();
    });
    $('#app').on('courseSet dataGotReady', (e, mapState = null) => {
      console.log("mapComponent courseSet event received! selectedCourse, mapState: ", this.$store.state.selectedCourse.name, mapState);
      this.loadCourse(mapState);
    });
    $('#app').on('checkPointSelected', (e, setCenter) => {
      console.log("mapComponent checkPointSelected event received! setCenter: ", setCenter);
      this.checkPointSelected(setCenter);
    });
    $('#app').on('requestResetMapSize', (e) => {
      console.log("mapComponent requestResetMapSize event received!");
      this.resetMapSize();
    });
    $('#app').on('requestCurrentLocation', (e, callback = null) => {
      console.log("mapComponent requestCurrentLocation event received!");
      this.reloadCurrentLocation(false, true, callback);
    });
    $('#app').on('updateMarkerState', (e) => {
      console.log("mapComponent updateMarkerState event received!");
      this.updateMarkerState();
    });
  },
}
</script>

<style scoped>
</style>
